export default __webpack_public_path__ + "static/media/user_access.aa6a0cf4.png";